<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-8">
                <div class="form-group mb-3">
                    <label for="moduleTitle">Title</label>
                    <input id="moduleTitle" type="text" class="form-control" [(ngModel)]="target.title" name="title" required />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group mb-3">
                    <label for="moduleSortOrder">Sort Order</label>
                    <input
                        id="moduleSortOrder"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.sortOrder"
                        name="sortOrder"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="moduleDescription">Description</label>
                    <textarea
                        id="moduleDescription"
                        rows="2"
                        class="form-control"
                        [(ngModel)]="target.description"
                        name="description"
                    ></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-9">
                <div class="form-group mb-3">
                    <label for="moduleYouTubeUrl">YouTube URL</label>
                    <input
                        id="moduleYouTubeUrl"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.youTubeUrl"
                        name="youTubeUrl"
                        required
                    />
                </div>
            </div>
            <div class="col-md-3 d-flex align-items-end">
                <div class="form-check mb-3">
                    <input id="moduleIsActive" type="checkbox" class="form-check-input" [(ngModel)]="target.isActive" name="isActive" />
                    <label class="form-check-label" for="moduleIsActive">Active</label>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">Quiz Questions</h5>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addQuestion()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Question
            </button>
        </div>

        @for (question of target.questions; track question.id; let i = $index) {
            <div class="border rounded p-3 mb-3">
                <div class="d-flex justify-content-between align-items-start mb-2">
                    <strong>Question {{ i + 1 }}</strong>
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeQuestion(i)">
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>
                <div class="form-group mb-3">
                    <label>Question Text</label>
                    <textarea
                        rows="2"
                        class="form-control"
                        [(ngModel)]="question.questionText"
                        [name]="'questionText' + i"
                        required
                    ></textarea>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group mb-3">
                            <label>Type</label>
                            <select class="form-select" [(ngModel)]="question.questionType" [name]="'questionType' + i">
                                @for (type of questionTypes; track type.value) {
                                    <option [ngValue]="type.value">{{ type.label }}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group mb-3">
                            <label>Correct Answer</label>
                            @if (question.questionType === 'TrueFalse') {
                                <select class="form-select" [(ngModel)]="question.correctAnswer" [name]="'correctAnswer' + i">
                                    @for (answer of trueFalseAnswers; track answer.value) {
                                        <option [ngValue]="answer.value">{{ answer.label }}</option>
                                    }
                                </select>
                            } @else {
                                <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="question.correctAnswer"
                                    [name]="'correctAnswer' + i"
                                    placeholder="A, B, C..."
                                />
                            }
                        </div>
                    </div>
                </div>

                @if (question.questionType === 'MultipleChoice') {
                    <div class="mb-3">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="mb-0">Answer Options</label>
                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="addOption(question)">Add Option</button>
                        </div>
                        @for (option of getOptions(question); track $index; let optionIndex = $index) {
                            <div class="input-group mb-2">
                                <input
                                    type="text"
                                    class="form-control"
                                    [value]="option"
                                    (input)="updateOption(question, optionIndex, $any($event.target).value)"
                                    [name]="'option' + i + optionIndex"
                                    placeholder="A. Option text"
                                />
                                <button type="button" class="btn btn-outline-danger" (click)="removeOption(question, optionIndex)">
                                    <fa-icon [icon]="faTrash"></fa-icon>
                                </button>
                            </div>
                        }
                    </div>
                }

                <div class="form-group mb-0">
                    <label>Explanation (shown when answer is wrong)</label>
                    <textarea rows="2" class="form-control" [(ngModel)]="question.explanation" [name]="'explanation' + i"></textarea>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
